import React from 'react'

const Loader = ({isCentered = false, size = 'btn-md'}) => {
	return (
		<div className={`${ isCentered ? 'text-center' : ''}`}><button type="button" className={`btn ${size} btn-light-primary`}><span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"><span className="visually-hidden">Се вчитува...</span></span>Се вчитува...</button></div>
	)
}

export default Loader